import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class ImageTitle extends React.PureComponent<ImageTitle.Props, ImageTitle.State> {
  public static sectionId = 'imgtitl';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings } = section
    if (!settings) {
      return <React.Fragment />
    }
    return (
      <section className={'dynamic-image-title'} style={{ background: settings.background }}>
        <div className={'max-w-8xl px-1-6 sm:px-2-4 2xl:px-22 xl:px-2-8 mx-auto py-3-2 lg:py-12-8'}>
          <div className={`flex flex-wrap flex-col-reverse ${settings.position == 'right' ? 'md:flex-row-reverse' : 'md:flex-row'}`}>
            <div className={'w-full md:w-1/2 relative'}>
              {settings.imageurl
                ? <Snippets.Link
                  title={settings.title}
                  onClick={() => trackPromotionClick(
                    [{
                      id: section.id,
                      name: settings.title,
                      creative: 'Image title'
                    }],
                    settings.linkurl
                  )}
                >
                  <Snippets.Image
                    alt={settings.title || "image with title"}
                    className={'bg-cover bg-center absolute inset-0 h-full'}
                    ratio={'5:6'}
                    src={settings.image}
                  />
                </Snippets.Link>
                : <Snippets.Image
                  alt={settings.title || "image with title"}
                  className={'bg-cover bg-center absolute inset-0 h-full'}
                  ratio={'5:6'}
                  src={settings.image}
                />}
            </div>
            <div className={`w-full md:w-1/2 md:p-4 pt-3-2 pb-4-4 text-center md:text-left flex items-center justify-center
              ${settings && settings.colour == 'light' ? 'text-white' : 'text-black'} 
              ${settings && settings.position == 'left' ? 'lg:pl-12-8' : 'lg:pr-12-8'}`}>
              <div>
                <Snippets.Heading
                  tag={'h2'}
                  className={'mb-4-4 text-3xl leading-none'}
                >
                  {settings.title}
                </Snippets.Heading>

                {settings.linktext ? (
                  <Snippets.Button
                    onClick={() => trackPromotionClick(
                      [{
                        id: section.id,
                        name: settings.title,
                        creative: 'Image title'
                      }],
                      settings.linkurl
                    )}
                    className={`md:w-auto uppercase tracking-wide  
                    ${settings && settings.colour == 'light' ? 'border-white text-white' : ''}`}
                    title={settings.linktext}
                    colour={'secondary'}
                  >
                    {settings.linktext}
                  </Snippets.Button>
                ) : null}

              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export namespace ImageTitle {
  export type Options = ShopifyNext.Section<{
    title: any;
    fullwidth: boolean;
    background: string;
    position: string;
    colour: string;
    image: string;
    content: string;
    linktext: string;
    linkurl: string;
    imageurl: string;
  }>;
  export interface Props extends GlobalProps {
    section: ImageTitle.Options;
  }
  export interface State { }
}
